export enum LoggingLevel {
    Debug = 'DEBUG',
    Production = 'Production',
}
